import React from 'react'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import { useDeleteItem } from '../../Hook/App'
import Spinner from '../../Components/Spinner'
function Index() {
    const { Delete, onChange, navigate, loading } = useDeleteItem()
    return (
        <Layout nav={false}>
            <HeaderMain lable="حذف اگهی" />
            <div className="delete-main">
                <div className='mt-3 mb-4 m-lg-3 font'>لطفا دلیل حذف اگهی خود را مشخص کنید</div>

                <div className='d-flex btn-deleted '>
                    <input name='case[]' onChange={onChange} value="در شیپور فروش رفت" type="checkbox" />
                    <div>در شیپور فروش رفت</div>
                </div>
                <div className='d-flex btn-deleted '>
                    <input name='case[]' onChange={onChange} value="منصرف شدم" type="checkbox" />
                    <div>منصرف شدم</div>
                </div>
                <div className='d-flex btn-deleted '>
                    <input name='case[]' onChange={onChange} value="دلایل دیگر" type="checkbox" />
                    <div>دلایل دیگر</div>
                </div>
                <div className='row btn-delete '>
                    <div className='col-6'>
                        <button onClick={() => { navigate(-1) }} className='cancle'>انصراف</button>
                    </div>
                    <div className='col-6'>
                        <button onClick={Delete} className='delete'>{loading.delete ? <Spinner sm /> : "حذف اگهی"}</button>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
export default Index